import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import { LocomotiveScrollProvider } from 'react-locomotive-scroll';
import 'locomotive-scroll/src/locomotive-scroll.scss';

//hook
import usePolicy from '../../hooks/ui/usePolicy';
import useRichText from '../../hooks/api/useRichText';

// Components
import Header from '../../components/header';
import Footer from '../../components/footer';

// Hooks
import usePrivacyMeta from '../../hooks/ui/usePrivacyMeta';

function PrivacyPolicy() {
    const containerRef = useRef(null);
    const { oggTitle, description, image } = usePrivacyMeta();

    const { title, update, intro, desc, terms } = usePolicy();
    const { parseBodyText } = useRichText();

    return (
        <>
            <Helmet>
                <title>{oggTitle}</title>
                <meta property="og:title" content={oggTitle} />
                <meta property="og:type" content="website" />
                <meta property="og:description" content={description} />
                <meta property="og:image" content={image.url} />
            </Helmet>
            <LocomotiveScrollProvider
                options={{
                    smooth: true,
                    scrollFromAnywhere: true,
                    multiplier: 0.75,
                    lerp: 0.03,
                    tablet: { smooth: true, multiplier: 0.55 },
                    smartphone: { smooth: false }
                }}
                watch={[]}
                containerRef={containerRef}>
                <div className={'page privacy-section'} data-scroll-container ref={containerRef}>
                    <Header />

                    <div className={'privacy-view'} data-scroll-section>
                        <h3 className={'privacy-view_title'}>{title}</h3>
                        <div className={'privacy-view_date'}>{update}</div>
                        <div className={'privacy-view_prompt'}>{parseBodyText(intro)}</div>
                        <div className={'privacy-view_desc'}>{parseBodyText(desc)}</div>

                        <div className={'terms'}>{parseBodyText(terms)}</div>
                    </div>

                    <Footer />
                </div>
            </LocomotiveScrollProvider>
        </>
    );
}

export default PrivacyPolicy;
